import { Component } from '@angular/core';
import { WidgetShell } from '../widget-shell.class';
import type { WidgetShellConfig } from '../widget-shell.interface';

export interface EmptyShellConfig extends WidgetShellConfig {}

@Component({
    selector: 'empty-shell',
    template: ''
})
export class EmptyShellComponent extends WidgetShell<EmptyShellConfig> {
    constructor() {
        super();
    }
}
